[{
  "label": "Engage Admins", "icon": "pi pi-fw pi-home", "root":  true, "expanded": true,
  "items": [
    { "label": "Dashboard", "icon": "pi pi-fw pi-home", "routerLink": ["dashboard"] },
    { "label": "Tenants", "class": "fa-solid fa-building-user custom-icon","routerLink": ["admin/tenants/list"] },
    { "label": "Admin Users", "icon": "pi pi-fw pi-users", "routerLink": ["admin/admin-users/list"]},
    { "label": "Menus", "class": "fa-solid fa-list-dropdown custom-icon","routerLink": ["admin/menus"] }
  ]},
  {
    "label": "Tenant Admin", "root":  true, "expanded": true,
    "icon": "pi pi-fw pi-star-fill",


    "items": [
      { "label": "Tenant Dashboard",
        "class": "fa-thin fa-grid-horizontal custom-icon",
        "routerLink": ["/tenant-dashboard"]
      },
      {
        "label": "Communication",
        "class": "fa-regular fa-address-book custom-icon",

        "items": [
          {
            "label": "Contacts",
            "class": "fa-regular fa-address-card custom-icon",
            "tenantRequired": true,
            "routerLink": [
              "tenant-contacts/list"
            ]
          },
          {
            "label": "Communication Usage",
            "class": "fa-solid fa-chart-user custom-icon",
            "tenantRequired": true,
            "routerLink": [
              "/tenant-communication-usage"
            ]
          }
        ]
      },
      { "label": "Tenant Users",
        "class": "fa-solid fa-users custom-icon",
        "tenantRequired": true,
        "routerLink": [
          "tenant-users/list"
        ]
      },
      {
        "label": "Tenant Menus",
        "icon": "pi pi-fw pi-list",
        "tenantRequired": true,
        "routerLink": [
          "/tenant-menus"
        ]
      },
      {
        "label": "Tenant Configs",
        "icon": "pi pi-fw pi-cog",
        "routerLink": [
          "/tenants/"
        ]
      },
      {
        "label": "Packages",
        "class": "fa-solid fa-chart-simple custom-icon",
        "tenantRequired": true,
        "routerLink": [
          "tier"
        ]
      },
      {
        "label": "Branding",
        "icon": "pi pi-fw pi-palette",
        "tenantRequired": true,
        "routerLink": [
          "branding"
        ]
      },
      { "label": "Vendor Settings",
        "class": "fa-solid fa-gear-complex-code custom-icon",
        "tenantRequired": true,
        "routerLink": [
          "vendor-settings/list"
        ]
      }
    ]
  }
]
